<template>
  <div class="basicAdd">
    <loading v-show="isLoading" />
    <el-form
      ref="ruleForm"
      label-position="right"
      label-width="100px"
      :model="ruleForm"
      size="mini"
      class="ruleForm"
    >
      <div class="headerContent">
        <label class="headeraddOrEdit"
          >{{ addOrEdit }}
          <span v-if="ruleForm.dataSourceUpdateTime" class="data-uptime"
            >({{ ruleForm.dataSourceUpdateTime | datetime }})</span
          >
        </label>
        <i
          class="headeraddOrEditClose el-icon-close lr"
          @click="handleCloseClick"
        ></i>
      </div>
      <ul class="tableFormUl">
        <li>
          <el-form-item
            prop="portCnName"
            label="港口中文"
            :rules="[
              { required: true, message: '请输入港口中文', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="ruleForm.portCnName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item
            prop="portEnName"
            label="港口英文"
            :rules="[
              { required: true, message: '请输入港口英文', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="ruleForm.portEnName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item
            prop="portCode"
            label="港口五字码"
            :rules="[
              { required: true, message: '请输入港口五字码', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="ruleForm.portCode"
              placeholder="请输入"
              maxlength="5"
              clearable
            />
          </el-form-item>

          <el-form-item prop="countryCode" label="国家简码">
            <el-input
              v-model="ruleForm.countryCode"
              placeholder="请输入"
              maxlength="5"
              clearable
            />
          </el-form-item>
          <el-form-item prop="countryEnName" label="国家英文名">
            <el-input
              v-model="ruleForm.countryEnName"
              placeholder="请输入"
              maxlength="5"
              clearable
            />
          </el-form-item>
          <el-form-item prop="countryCnName" label="国家中文名">
            <el-input
              v-model="ruleForm.countryCnName"
              placeholder="请输入"
              maxlength="5"
              clearable
            />
          </el-form-item>
        </li>
        <li>
          <el-form-item
            prop="baseCode"
            label="标准五字码"
            :rules="[
              { required: true, message: '请选择标准五字码', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="ruleForm.baseCode"
              style="width: 100%"
              placeholder="请输入并选择"
              filterable
              remote
              clearable
              :remote-method="remoteportCode"
              default-first-option
              @change="changeBase"
              @focus="portCodeFocus"
            >
              <el-option
                v-for="item in portList"
                :key="item.id"
                :label="item.code"
                :value="item.code"
              >
                <template>
                  {{ item.portCode }}
                </template>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="basePortEn" label="标准港口">
            <el-input v-model="ruleForm.basePortEn" read-only disabled />
          </el-form-item>
          <el-form-item prop="baseTerminalCn" label="标准码头">
            <el-select
              v-model="ruleForm.baseTerminalCn"
              clearable
              style="width: 100%"
              placeholder="请选择"
              loading-text="加载中"
              @focus="focusBaseTer"
              @change="baseTerChange"
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.terminalCn"
                :value="item.terminalCn"
              />
            </el-select>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="baseCountryCn" label="标准国家中文">
            <el-input v-model="ruleForm.baseCountryCn" read-only disabled />
          </el-form-item>
          <el-form-item prop="baseCountryCode" label="标准国家简码">
            <el-input v-model="ruleForm.baseCountryCode" read-only disabled />
          </el-form-item>
          <el-form-item prop="portTimezone" label="时区">
            <el-select
              v-model="ruleForm.portTimezone"
              filterable
              placeholder="时区"
            >
              <el-option v-for="z in zones" :key="z" :value="z" :label="z" />
            </el-select>
          </el-form-item>
        </li>
        <li style="text-align: center">
          <el-button
            size="small"
            class="clicksColor"
            @click="handleSaveClick('ruleForm')"
          >
            保存
          </el-button>
        </li>
        <li style="clear: both"></li>
      </ul>
    </el-form>
  </div>
</template>

<script>
// socket功能
import loading from '@/components/Loading/loading.vue'
import dayjs from 'dayjs'

export default {
  filters: {
    datetime(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
  },
  components: {
    loading,
  },
  props: ['dialogStatus', 'tablesRow'],

  data() {
    return {
      disabled: true,
      addOrEdit: '',
      portList: [],
      //标准码头
      terminalList: [],
      isLoading: false,
      countryDisabled: true,
      ruleForm: {
        // // 标准码头
        // baseCode: "",
        // // 标准五字码
        // baseTerminalCn: "",
        // // 标准五字码id
        // baseTerminalId: "",
        // // 港口中文
        // portCnName: "",
        // // 港口英文
        // portEnName: "",
        // // 标准港口
        // basePortEn: "",
        // // 港口code
        // portCode: "",
        // // 标准国家中文
        // baseCountryCn: "",
        // // 标准国家简码
        // baseCountryCode: "",
      },
      countryEnList: [],
      cityEnList: [],
      routeCnList: [],
      terminalDelecList: [],
    }
  },

  computed: {
    zones() {
      return [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, -11, -10, -9, -8, -7, -6, -5,
        -4, -3, -2, -1,
      ].map(k => k.toString())
    },
  },
  // computed: {
  //   inputEn: {
  //     get() {
  //       return this.ruleForm.portCode.toUpperCase();
  //     },
  //     set(value) {
  //       this.ruleForm.portCode = value.replace(/[^\w]/gi, "");
  //     },
  //   },
  // },
  mounted() {
    this.$watch(
      () => [this.dialogStatus, this.tablesRow && this.tablesRow.id],
      this.refresh,
      {
        immediate: true,
      }
    )
  },
  methods: {
    //保存
    async handleSaveClick(ruleForm) {
      try {
        let valid = await this.$refs[ruleForm].validate()
        if (!valid) return
        this.isLoading = true
        this.$axios
          .post(
            this.commonJs.localUrl + `/schedules/aisPort/save`,
            this.ruleForm,
            {
              headers: {
                Authorization: `Bearer ${this.getAuthorization()}`,
                AccessToken: this.getCookie('token'),
              },
            }
          )
          .then(res => {
            if (res.data.status === 1) {
              this.$message({
                type: 'success',
                message: '保存成功!',
              })
              this.isLoading = false
              this.aisSelect()

              this.$emit('successful')
            } else {
              this.$message({
                type: 'error',
                message: res.data.message,
              })
              this.isLoading = false
            }
          })
      } catch (e) {}
    },
    // 标准五字码
    changeBase(value) {
      if (value === null) {
        return
      }
      let obj = this.portList.find(item => {
        return item.code === value
      })
      if (obj) {
        this.ruleForm.basePortEn = obj.portEn
        this.ruleForm.baseCountryCn = obj.countryCn
        this.ruleForm.baseCountryCode = obj.countryCode
        this.focusBaseTer()
      }
      if (!value) {
        this.ruleForm.basePortEn = ''
        this.ruleForm.baseCountryCn = ''
        this.ruleForm.baseCountryCode = ''
        this.ruleForm.baseTerminalCn = ''
      }
    },
    //五子码 远程查询
    remoteportCode(value) {
      this.$axios
        .get(
          this.commonJs.localUrl +
            `/schedules/terminal/queryBaseCode?baseCode=${value}`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        .then(res => {
          if (res.data.status === 1) {
            this.portList = res.data.content
          }
        })
    },
    //五子码  focus
    portCodeFocus() {
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/terminal/queryBaseCode`, {
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token'),
          },
        })
        .then(res => {
          if (res.data.status === 1) {
            this.portList = res.data.content
          }
        })
    },
    //获取标准码头
    focusBaseTer() {
      if (!this.ruleForm.baseCode) {
        return
      }
      this.terminalList = []
      this.$axios
        .get(
          this.commonJs.localUrl +
            `/schedules/port/getTerminaByPortCd?portcd=${this.ruleForm.baseCode}`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        .then(res => {
          this.terminalList = res.data.content
          if (this.terminalList.length > 0) {
            this.ruleForm.baseTerminalCn = this.terminalList[0].terminalCn
            this.ruleForm.baseTerminalId = this.terminalList[0].id
            this.ruleForm.terminalId = this.terminalList[0].id
          } else {
            this.ruleForm.baseTerminalCn = ''
            this.ruleForm.baseTerminalId = ''
            this.ruleForm.terminalId = ''
          }
        })
    },
    // 码头change事件
    baseTerChange(value) {
      if (value === null) {
        return
      }
      let obj = this.terminalList.find(item => {
        return item.terminalCn === value
      })
      if (obj) {
        this.ruleForm.baseTerminalId = obj.id
        this.ruleForm.terminalId = obj.id
      }
      if (!value) {
        this.ruleForm.baseTerminalId = ''
        this.ruleForm.terminalId = ''
      }
    },
    //关闭事件
    handleCloseClick() {
      this.$emit('handleClose')
    },
    aisSelect() {
      this.$emit('aisSelect')
    },

    async refresh() {
      this.ruleForm = {}

      const $ruleForm = this.$refs['ruleForm']

      if ($ruleForm) {
        $ruleForm.clearValidate()
      }

      if (this.dialogStatus === '新增') {
        this.addOrEdit = '新增'
        this.ruleForm = this.tablesRow || {}

        // console.log(this.tablesRow);
      } else if (this.dialogStatus === '编辑') {
        this.addOrEdit = '编辑'
        this.isLoading = true

        const ops = {
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
          },
        }

        try {
          const res = await this.$axios.get(
            this.commonJs.localUrl +
              `/schedules/aisPort/get?id=${this.tablesRow.id}`,
            ops
          )

          if (res.data.status === 1) {
            this.ruleForm = res.data.content

            if (this.ruleForm.baseCode) {
              const baseRes = await this.$axios.get(
                this.commonJs.localUrl +
                  `/schedules/terminal/queryBaseCode?baseCode=${this.ruleForm.baseCode}`,
                ops
              )

              if (
                baseRes.data.status === 1 &&
                baseRes.data.content.length > 0
              ) {
                this.$set(
                  this.ruleForm,
                  'baseCountryCn',
                  baseRes.data.content[0].countryCn
                )
                this.$set(
                  this.ruleForm,
                  'baseCountryCode',
                  baseRes.data.content[0].countryCode
                )
                this.$set(
                  this.ruleForm,
                  'basePortEn',
                  baseRes.data.content[0].portEn
                )
              }
            }
          }
        } finally {
          this.isLoading = false
        }
      }
    },

    //编辑添加
    // protAdd() {
    //   this.terminal.push({
    //     id: "", //码头id 修改和删除必填
    //     terminalCn: "", //码头中文 新增和修改必填
    //     terminal: "", //码头英文 新增和修改必填
    //     delFlag: "", // 如果是删除 delFlag必传1
    //   });
    // },
    //编辑删除
    // protDelect(index) {
    //   var delectProt = this.terminal.splice(index, 1)[0];
    //   if (this.dialogStatus === "编辑") {
    //     if (delectProt.id) {
    //       delectProt.delFlag = 1;
    //       this.terminalDelecList.push(delectProt);
    //     }
    //   }
    // },
    //立即添加 跳转到码头
    // routeAddLink() {
    //     this.$router.push('/BasicData/Dock')
    // },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item--mini .el-form-item__content {
  margin-left: 100px !important;
}

::v-deep .el-form-item__content {
  margin-left: 100px !important;
}

.basicAdd {
  position: relative;
}

.lf {
  float: left;
}

.lr {
  float: right;
}

.clicksColor {
  padding: 9px 35px;
  color: #fff;
  background-color: #3bafda;
}

.headerContent {
  border-bottom: 1px solid #797979;
  padding-bottom: 10px;
  line-height: 1;
}

.headeraddOrEdit {
  font-size: 18px;
  margin-left: 10px;

  .data-uptime {
    font-size: 12px;
    margin-left: 10px;
    color: #b1b1b1;
  }
}

.headeraddOrEditClose {
  margin-right: 10px;
  font-size: 16px;
  cursor: pointer;
}

.tableFormUl {
  padding-top: 20px;

  li:nth-of-type(1) {
    margin-top: 0px;
  }

  li {
    margin-top: 20px;

    .el-form-item {
      display: inline-block;
      width: 300px;
      margin-right: 20px;
    }
  }
}

.proteAddLi {
  width: 750px;
}

.proteAddDelec {
  width: 600px;
}

.protClass {
  display: inline-block;
  margin-bottom: 20px;
}

.portadddelect {
  margin-right: 20px;
}

.nowAdd {
  color: #3bafda;
  cursor: pointer;
}

.delenowAdd {
  color: red;
  cursor: pointer;
}
</style>
